import { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import styled from 'styled-components';
import { GenericConfig } from '../genericConfigForm';
import validator from 'validator';
import Button from '../components/Button';
import RadioButton from '../components/RadioButton';
import { getHomeUserByHomeUserId, updateHomeUser, addNewHomeUser } from '../services/GenericAddEditFormService';

const Title = styled.h1(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    font-weight: ${type.weight.black};
    color: ${color.grayscale[0]};
    text-align: center;
    margin-bottom: 2rem;
  `;
});

const Card = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background-color: ${color.grayscale[1000]};
    border-radius: 16px;
    box-shadow: ${shadow.dialog};
    padding: 38px 32px;
    width: max(70%, 1440px);
    margin: 0 auto;
  `;
});

const CardHeader = styled.h1(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.regular};
    font-weight: ${type.weight.black};
    color: ${color.grayscale[0]};
    text-align: center;
    margin-bottom: 2rem;
  `;
});

const Form = styled.form(() => {
  return `
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
    grid-template-rows: auto;
    gap: 20px;
    width: max(45%, 650px);
    margin:auto;
    
    justify-content: center;    
  `;
});

const BasicContainer = styled.label(() => {
  return `
  `;
});

const Label = styled.label(({ theme }) => {
  return `
    display: block;
    color: ${theme.color.grayscale[0]}
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  `;
});

const Input = styled.input(({ theme }) => {
  const { color } = theme;
  return `
  border-color: ${color.grayscale[0]};
  border-radius: 0.5rem;
  border-width: 1px;

  width: 100%;
  padding: 10px;

  &.error {
    border-color: ${color.primary.regular};
  }
  `;
});

const RadioContainer = styled.div(() => {
  return `
    display: flex;
    padding: 10px 10px 10px 0px;
  `;
});

const AgeInput = styled.input(({ theme }) => {
  const { color } = theme;
  return `
    border-color: ${color.grayscale[0]};
    border-radius: 0.5rem;
    border-width: 1px;

    width:50%;
    padding: 10px;

    &.error {
      border-color: ${color.primary.regular};
    }
  `;
});

const NotesContainer = styled.label(() => {
  return `
    grid-column: 1 / span 2;
  `;
});

const NotesInput = styled.textarea(({ theme }) => {
  const { color } = theme;
  return `
    border: 1px solid ${color.grayscale[0]};
    border-radius: 0.5rem;
    width: 100%;

    padding: 10px;

    &.error {
      border-color: ${color.primary.regular};
    }
  `;
});

const FirstColSpanContainer = styled.div(() => {
  return `
    grid-column: 1;
  `;
});

const SecColSpanContainer = styled.div(() => {
  return `
    grid-column: 2;
  `;
});

const ButtonContainer = styled.div`
  grid-column: 1 / span 2;
  text-align: center;
`;

const ErrorMessage = styled.div(({ theme }) => {
  return `
    color: ${theme.color.primary.regular};
    font-style: italic;
    margin-top: 0.75rem;
  `;
});

const GenericAddForm = (props) => {
  const [navigate, setNavigate] = useState('');

  const [homeUser, setHomeUser] = useState(null);

  let playerName = '';
  let tmpEmail = '';
  if (homeUser === null || homeUser === undefined) {
    if (props.location.state.data.player && props.location.state.data.player.player_name) {
      playerName = props.location.state.data.player.player_name;
    }
  } else {
    playerName = homeUser.first_name + ' ' + homeUser.last_name;
    tmpEmail = homeUser.email;
  }

  let playerId = -1;
  if (props.location.state.data && props.location.state.data.player && props.location.state.data.player.id) {
    playerId = props.location.state.data.player.id;
  }

  let config = {};
  if (props.location.state.data && props.location.state.data.type) {
    config = GenericConfig().find((item) => item.FormType === props.location.state.data.type);
  }

  const [genericAddEditForm, setGenericAddEditForm] = useState({
    type: props.location.state.data.type,
    config: config,
    playerId: playerId ? playerId : -1,
    canFormBeSubmitted: false,
    fields: {
      firstName: {
        name: 'firstName',
        value: homeUser ? homeUser.first_name : playerName.split(' ')[0],
        errorMsg: 'First name is required',
        valid: true,
        toSendToBE: config.askFor_FirstName,
      },

      lastName: {
        name: 'lastName',
        value: playerName ? playerName.slice(playerName.indexOf(' ')) : '',
        errorMsg: 'Last name is required',
        valid: true,
        toSendToBE: config.askFor_LastName,
      },

      email: {
        name: 'email',
        value: tmpEmail ? tmpEmail : '',
        errorMsg: 'Please insert a valid email address',
        valid: true,
        toSendToBE: config.askFor_Email,
      },

      phoneNum: {
        name: 'phoneNum',
        value: homeUser ? homeUser.phone_number : '',
        errorMsg: 'Please insert a valid phone number',
        valid: true,
        toSendToBE: config.askFor_PhoneNumber,
      },

      age: {
        name: 'age',
        value: '',
        errorMsg: 'Age must be between 1 - 130',
        valid: true,
        toSendToBE: config.askFor_Age,
      },

      gender: {
        name: 'gender',
        value: '',
        errorMsg: '',
        valid: true,
        toSendToBE: config.askFor_Gender,
      },

      notes: {
        name: 'notes',
        value: '',
        errorMsg: '',
        valid: true,
        toSendToBE: config.askFor_Notes,
      },

      username: {
        name: 'username',
        value: '',
        errorMsg: 'Username is required',
        valid: true,
        toSendToBE: config.askFor_Username,
      },

      login: {
        name: 'login',
        value: tmpEmail ? tmpEmail : '',
        errorMsg: 'Login is required',
        valid: true,
        toSendToBE: config.askFor_Login,
      },

      password: {
        name: 'password',
        value: '',
        errorMsg: '',
        valid: true,
        toSendToBE: true,
      },

      passwordConfirmation: {
        name: 'passwordConfirmation',
        value: '',
        errorMsg: '',
        valid: true,
        toSendToBE: true,
      },
    },
  });

  useEffect(() => {
    if (homeUser === null && props.location.state.data.player && props.location.state.data.player.home_user_id) {
      getHomeUserByHomeUserId(props.location.state.data.player.home_user_id).then((result) => {
        if (result && result.status === 200) {
          if (result.data.success === false) {
            alert(result.data.message);
          } else {
            setHomeUser(result.data.home_user);

            setGenericAddEditForm({
              ...genericAddEditForm,
              fields: {
                ...genericAddEditForm.fields,
                firstName: {
                  ...genericAddEditForm.fields.firstName,
                  value: result.data.home_user.first_name,
                },
                lastName: {
                  ...genericAddEditForm.fields.lastName,
                  value: result.data.home_user.last_name,
                },
                phoneNum: {
                  ...genericAddEditForm.fields.phoneNum,
                  value: result.data.home_user.phone_number,
                },
                login: {
                  ...genericAddEditForm.fields.login,
                  value: result.data.home_user.login,
                },
              },
            });
          }
        }
      });
    }
  }, [props.location.state.data.player, homeUser, setHomeUser, genericAddEditForm, setGenericAddEditForm]);

  const checkIfEmptyInput = (valueInput) => {
    return valueInput.trim() === '';
  };

  const checkIfPasswordIsValid = (value, nameOfFieldWasChange) => {
    let tmpPass = '';
    let tmpFirstName = '';
    let tmpLastName = '';
    let tmpLogin = '';

    // firstName was changed
    if (nameOfFieldWasChange === genericAddEditForm.fields.firstName.name) {
      tmpPass = genericAddEditForm.fields.password.value.toLowerCase();
      tmpFirstName = value.toLowerCase();
      tmpLastName = genericAddEditForm.fields.lastName.value.toLowerCase();
      tmpLogin = genericAddEditForm.fields.login.value.toLowerCase();
    }

    // lastName was changed
    else if (nameOfFieldWasChange === genericAddEditForm.fields.lastName.name) {
      tmpPass = genericAddEditForm.fields.password.value.toLowerCase();
      tmpFirstName = genericAddEditForm.fields.firstName.value.toLowerCase();
      tmpLastName = value.toLowerCase();
      tmpLogin = genericAddEditForm.fields.login.value.toLowerCase();
    }

    // login was changed
    else if (nameOfFieldWasChange === genericAddEditForm.fields.login.name) {
      tmpPass = genericAddEditForm.fields.password.value.toLowerCase();
      tmpFirstName = genericAddEditForm.fields.firstName.value.toLowerCase();
      tmpLastName = genericAddEditForm.fields.lastName.value.toLowerCase();
      tmpLogin = value.toLowerCase();
    }

    // password was changed
    else {
      tmpPass = value.toLowerCase();
      tmpFirstName = genericAddEditForm.fields.firstName.value.toLowerCase();
      tmpLastName = genericAddEditForm.fields.lastName.value.toLowerCase();
      tmpLogin = genericAddEditForm.fields.login.value.toLowerCase();
    }

    if (
      (tmpFirstName.trim() !== '' && tmpPass.includes(tmpFirstName)) ||
      (tmpLastName.trim() !== '' && tmpPass.includes(tmpLastName)) ||
      (tmpLogin.trim() !== '' && tmpPass.includes(tmpLogin)) ||
      tmpPass.includes('password') ||
      tmpPass.includes('restore')
    ) {
      return false;
    }
    return true;
  };

  const setValidInput = (field, value) => {
    setGenericAddEditForm({
      ...genericAddEditForm,
      fields: {
        ...genericAddEditForm.fields,
        [field]: {
          ...genericAddEditForm.fields[field],
          valid: true,
          value: value,
        },
      },
    });
  };

  const setNotValidInput = (field, value) => {
    setGenericAddEditForm({
      ...genericAddEditForm,
      canFormBeSubmitted: false,
      fields: {
        ...genericAddEditForm.fields,
        [field]: {
          ...genericAddEditForm.fields[field],
          valid: false,
          value: value,
        },
      },
    });
  };

  const handleFormInputChange = (e) => {
    // validation for: all the required fields like: first name, last name, password, etc...
    if (e.target.required) {
      // check if input is empty
      const isInputEmpty = checkIfEmptyInput(e.target.value);
      // IS empty
      if (isInputEmpty) {
        setGenericAddEditForm({
          ...genericAddEditForm,
          canFormBeSubmitted: false,
          fields: {
            ...genericAddEditForm.fields,
            [e.target.name]: {
              ...genericAddEditForm.fields[e.target.name],
              valid: false,
              value: e.target.value,
              errorMsg: 'This field can NOT be empty',
            },
          },
        });
      }
      // less than 30 characters
      else if (e.target.value.length > 30) {
        setGenericAddEditForm({
          ...genericAddEditForm,
          canFormBeSubmitted: false,
          fields: {
            ...genericAddEditForm.fields,
            [e.target.name]: {
              ...genericAddEditForm.fields[e.target.name],
              valid: false,
              value: e.target.value,
              errorMsg: 'This field must be less than 30 characters',
            },
          },
        });
      }

      // NOT empty
      else {
        let isPasswordStrong = false;
        let isPasswordValid = false;
        let isPasswordConfirmationEqualToPassword = false;

        // password was changed
        if (e.target.name === genericAddEditForm.fields.password.name) {
          isPasswordStrong = validator.isStrongPassword(e.target.value);
          isPasswordValid = checkIfPasswordIsValid(e.target.value, genericAddEditForm.fields.password.name);
          isPasswordConfirmationEqualToPassword =
            e.target.value === genericAddEditForm.fields.passwordConfirmation.value;
        }

        // password confirmation was changed
        else if (e.target.name === genericAddEditForm.fields.passwordConfirmation.name) {
          isPasswordStrong = validator.isStrongPassword(genericAddEditForm.fields.password.value);
          isPasswordValid = checkIfPasswordIsValid(
            genericAddEditForm.fields.password.value,
            genericAddEditForm.fields.passwordConfirmation.name
          );
          isPasswordConfirmationEqualToPassword = genericAddEditForm.fields.password.value === e.target.value;
        }

        // firstName / lastName / login was changed
        else {
          isPasswordStrong = validator.isStrongPassword(genericAddEditForm.fields.password.value);
          isPasswordValid = checkIfPasswordIsValid(e.target.value, e.target.name);
          isPasswordConfirmationEqualToPassword =
            genericAddEditForm.fields.password.value === genericAddEditForm.fields.passwordConfirmation.value;
        }

        setGenericAddEditForm({
          ...genericAddEditForm,
          canFormBeSubmitted: isPasswordStrong
            ? isPasswordValid
              ? isPasswordConfirmationEqualToPassword
                ? true
                : false
              : false
            : false,
          fields: {
            ...genericAddEditForm.fields,
            [e.target.name]: {
              ...genericAddEditForm.fields[e.target.name],
              value: e.target.value,
              valid: true,
              errorMsg: '',
            },
            password: {
              ...genericAddEditForm.fields.password,
              value:
                e.target.name === genericAddEditForm.fields.password.name
                  ? e.target.value
                  : genericAddEditForm.fields.password.value,
              valid: isPasswordStrong && isPasswordValid,
              errorMsg: !isPasswordStrong
                ? 'Password must contain at least 8 characters: 1 lower case, 1 upper case, 1 number and 1 symbol'
                : !isPasswordValid
                ? "Password can NOT contain your: name, last name, username, 'restore' or 'password'"
                : '',
            },
            passwordConfirmation: {
              ...genericAddEditForm.fields.passwordConfirmation,
              value:
                e.target.name === genericAddEditForm.fields.passwordConfirmation.name
                  ? e.target.value
                  : genericAddEditForm.fields.passwordConfirmation.value,
              valid: isPasswordConfirmationEqualToPassword,
              errorMsg: !isPasswordConfirmationEqualToPassword ? 'Password confirmation must be equal to Password' : '',
            },
          },
        });
      }
    }

    // NOT REQUIRED
    else {
      const isInputEmpty = checkIfEmptyInput(e.target.value);
      if (isInputEmpty) {
        setValidInput(e.target.name, e.target.value);
      }
      // NOT REQUIRED AND NOT EMPTY
      else {
        if (e.target.name === genericAddEditForm.fields.email.name) {
          const isEmailValid = validator.isEmail(e.target.value);
          if (!isEmailValid) {
            setNotValidInput(e.target.name, e.target.value);
          } else {
            setValidInput(e.target.name, e.target.value);
          }
        }

        if (e.target.name === genericAddEditForm.fields.phoneNum.name) {
          if (genericAddEditForm.fields.phoneNum === '' || e.target.value === '') {
            setValidInput(e.target.name, '');
          } else {
            const isPhoneNumValid = validator.isMobilePhone(e.target.value, ['en-US']);
            if (!isPhoneNumValid) {
              setNotValidInput(e.target.name, e.target.value);
            } else {
              setValidInput(e.target.name, e.target.value);
            }
          }
        }

        if (e.target.name === genericAddEditForm.fields.age.name) {
          if (e.target.value <= 0 || e.target.value >= 130) {
            setNotValidInput(e.target.name, e.target.value);
          } else {
            setValidInput(e.target.name, e.target.value);
          }
        }

        if (
          e.target.name === genericAddEditForm.fields.username.name ||
          e.target.name === genericAddEditForm.fields.gender.name ||
          e.target.name === genericAddEditForm.fields.notes.name
        ) {
          setValidInput(e.target.name, e.target.value);
        }
      }
    }
  };

  const blockInvalidAgeLetters = (e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
  const blockInvalidPhoneLetters = (e) => ['e', 'E', '-', '.'].includes(e.key) && e.preventDefault();

  const handleSubmit = (e) => {
    e.preventDefault();

    // EDIT PLAYER
    if (playerId !== -1) {
      const fieldsToSendToBE = {};
      for (const field in genericAddEditForm.fields) {
        if (!genericAddEditForm.fields[field].valid) {
          return;
        } else if (genericAddEditForm.fields[field].toSendToBE) {
          fieldsToSendToBE[field] = genericAddEditForm.fields[field].value;
        }
      }

      fieldsToSendToBE['playerId'] = genericAddEditForm.playerId;
      fieldsToSendToBE['home_user'] = homeUser;

      // EDIT HOME USER
      if (homeUser) {
        updateHomeUser(fieldsToSendToBE).then((result) => {
          if (result && result.status === 200) {
            if (result.data.success === false) {
              alert(result.data.message);
            } else {
              alert('home user was SUCCESSFULLY updated');
              setNavigate('/players');
            }
          }
        });
      }
      // ADD NEW HOME USER
      else {
        addNewHomeUser(fieldsToSendToBE).then((result) => {
          if (result && result.status === 200) {
            if (result.data.success === false) {
              alert(result.data.message);
            } else {
              alert('home user was SUCCESSFULLY created');
              setNavigate('/players');
            }
          }
        });
      }
    }
    // ADD NEW PLAYER
    else {
      // console.log('add new player');
    }
  };

  if (navigate !== '') {
    return <Redirect to={navigate} />;
  } else {
    return (
      <div>
        {genericAddEditForm.type && genericAddEditForm.config && (
          <div>
            <Title>{genericAddEditForm.config.Title}</Title>
            <i className="fas-solid fas-house-laptop" aria-hidden="true"></i>
            <i className="fa-solid fa-house-laptop blue-color"></i>
            <i className="fa-solid fa-house-laptop green-color"></i>
            <i className="fa-solid fa-house-laptop teal-color"></i>
            <i className="fa-solid fa-house-laptop yellow-color"></i>
            <i className="fa-solid fa-house-laptop red-color"></i>
            <Card>
              <CardHeader>{genericAddEditForm.config.SubTitle}</CardHeader>
              <Form onSubmit={(e) => handleSubmit(e)}>
                {genericAddEditForm.config.askFor_FirstName && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.firstName.name}>First Name</Label>
                    <Input
                      className={genericAddEditForm.fields.firstName.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.firstName.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={true}
                      placeholder="Enter first name"
                      name={genericAddEditForm.fields.firstName.name}
                      id={genericAddEditForm.fields.firstName.name}
                    ></Input>
                    {!genericAddEditForm.fields.firstName.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.firstName.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_LastName && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.lastName.name}>Last Name</Label>
                    <Input
                      className={genericAddEditForm.fields.lastName.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.lastName.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={true}
                      placeholder="Enter last name"
                      name={genericAddEditForm.fields.lastName.name}
                      id={genericAddEditForm.fields.lastName.name}
                    ></Input>
                    {!genericAddEditForm.fields.lastName.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.lastName.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Email && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.email.name}>Email</Label>
                    <Input
                      className={genericAddEditForm.fields.email.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.email.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={false}
                      placeholder="Enter email"
                      name={genericAddEditForm.fields.email.name}
                      id={genericAddEditForm.fields.email.name}
                      type="email"
                    ></Input>
                    {!genericAddEditForm.fields.email.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.email.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_PhoneNumber && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.phoneNum.name}>Phone Number</Label>
                    <Input
                      type="number"
                      className={genericAddEditForm.fields.phoneNum.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.phoneNum.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      onKeyDown={blockInvalidPhoneLetters}
                      required={false}
                      placeholder="Enter phone number"
                      name={genericAddEditForm.fields.phoneNum.name}
                      id={genericAddEditForm.fields.phoneNum.name}
                    ></Input>
                    {!genericAddEditForm.fields.phoneNum.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.phoneNum.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Age && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.age.name}>Age (optional)</Label>
                    <AgeInput
                      className={genericAddEditForm.fields.age.valid ? '' : 'error'}
                      type="number"
                      value={genericAddEditForm.fields.age.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      onKeyDown={blockInvalidAgeLetters}
                      required={false}
                      placeholder="Enter age"
                      name={genericAddEditForm.fields.age.name}
                      id={genericAddEditForm.fields.age.name}
                    ></AgeInput>
                    {!genericAddEditForm.fields.age.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.age.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Gender && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.gender.name}>Gender (optional)</Label>
                    <RadioContainer>
                      <RadioButton
                        checked={genericAddEditForm.fields.gender.value === 'Male'}
                        value="Male"
                        label="Male"
                        onChange={handleFormInputChange}
                        name={genericAddEditForm.fields.gender.name}
                        required={false}
                      />

                      <RadioButton
                        checked={genericAddEditForm.fields.gender.value === 'Female'}
                        value="Female"
                        label="Female"
                        onChange={handleFormInputChange}
                        name={genericAddEditForm.fields.gender.name}
                        required={false}
                      />

                      <RadioButton
                        checked={genericAddEditForm.fields.gender.value === 'Other'}
                        value="Other"
                        label="Other"
                        onChange={handleFormInputChange}
                        name={genericAddEditForm.fields.gender.name}
                        required={false}
                      />
                    </RadioContainer>
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Notes && (
                  <NotesContainer>
                    <Label htmlFor={genericAddEditForm.fields.notes.name}>Notes (optional)</Label>
                    <NotesInput
                      value={genericAddEditForm.fields.notes.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={false}
                      name={genericAddEditForm.fields.notes.name}
                      id={genericAddEditForm.fields.notes.name}
                    ></NotesInput>
                  </NotesContainer>
                )}
                {genericAddEditForm.config.askFor_Username && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.username.name}>Username</Label>
                    <Input
                      className={genericAddEditForm.fields.username.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.username.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={false}
                      placeholder="Enter username"
                      name={genericAddEditForm.fields.username.name}
                      id={genericAddEditForm.fields.username.name}
                    ></Input>
                    {!genericAddEditForm.fields.username.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.username.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Login && (
                  <BasicContainer>
                    <Label htmlFor={genericAddEditForm.fields.login.name}>Login</Label>
                    <Input
                      autoComplete="username"
                      className={genericAddEditForm.fields.login.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.login.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={true}
                      placeholder="Enter login"
                      name={genericAddEditForm.fields.login.name}
                      id={genericAddEditForm.fields.login.name}
                    ></Input>
                    {!genericAddEditForm.fields.login.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.login.errorMsg}</ErrorMessage>
                    )}
                  </BasicContainer>
                )}
                {genericAddEditForm.config.askFor_Password && (
                  <FirstColSpanContainer>
                    <Label htmlFor={genericAddEditForm.fields.password.name}>Password</Label>
                    <Input
                      autoComplete="new-password"
                      type="password"
                      className={genericAddEditForm.fields.password.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.password.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={true}
                      placeholder="Enter password"
                      name={genericAddEditForm.fields.password.name}
                      id={genericAddEditForm.fields.password.name}
                    ></Input>
                    {!genericAddEditForm.fields.password.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.password.errorMsg}</ErrorMessage>
                    )}
                  </FirstColSpanContainer>
                )}
                {genericAddEditForm.config.askFor_Password && (
                  <SecColSpanContainer>
                    <Label htmlFor={genericAddEditForm.fields.passwordConfirmation.name}>Password Confirmation</Label>
                    <Input
                      autoComplete="new-password"
                      type="password"
                      className={genericAddEditForm.fields.passwordConfirmation.valid ? '' : 'error'}
                      value={genericAddEditForm.fields.passwordConfirmation.value}
                      setState={setGenericAddEditForm}
                      onChange={handleFormInputChange}
                      required={true}
                      placeholder="Enter password again"
                      name={genericAddEditForm.fields.passwordConfirmation.name}
                      id={genericAddEditForm.fields.passwordConfirmation.name}
                    ></Input>
                    {!genericAddEditForm.fields.passwordConfirmation.valid && (
                      <ErrorMessage>{genericAddEditForm.fields.passwordConfirmation.errorMsg}</ErrorMessage>
                    )}
                  </SecColSpanContainer>
                )}
                <ButtonContainer>
                  <Button type="submit" disabled={genericAddEditForm.valid}>
                    SAVE
                  </Button>
                </ButtonContainer>
                <ButtonContainer>
                  <Button secondary="true" onClick={() => setNavigate('/players')}>
                    CANCEL
                  </Button>
                </ButtonContainer>
              </Form>
            </Card>
          </div>
        )}
      </div>
    );
  }
};

export default GenericAddForm;
